import { userListItem } from '@/components/streams/stream-invite/user-list-item.css.ts';
import { UserBadge } from '@/components/user-badge/user-badge.tsx';

export const UserListItem = ({ userId }: { userId: string }) => {
  return (
    <div className={userListItem}>
      <UserBadge id={userId} size={'xm'} />
    </div>
  );
};
